export const codes: Record<string, string> = {
  'molding': 'molding-rfq',
  'partition': 'partition-rfq',
  'piping': 'piping-rfq',
  'kitchenhood': 'kitchenhood-rfq',
  'furniturerepair': 'furniturerepair-rfq',
  'odorremoval': 'odorremoval-rfq',
  'jointtile': 'jointtile-rfq',
  'sterilization': 'sterilization-rfq',
  'kitchen': 'kitchen-rfq',
  'pestcontrol': 'pestcontrol-rfq',
  'acinstallation': 'acinstallation-rfq',
  'homeinterior': 'homeinterior-rfq',
  'doorlock': 'doorlock-rfq',
  'painting': 'painting-rfq',
  'electrician': 'electrician-rfq',
  'iphone': 'iphone-rfq',
  'floormaintenance': 'floormaintenance-rfq',
  'storageconsultation': 'storageconsultation-rfq',
  'glasswindow': 'glasswindow-rfq',
  'curtains': 'curtains-rfq',
  'wastedisposal': 'wastedisposal-rfq',
  'film': 'film-rfq',
  'carwash': 'carwash',
  'sink': 'sink-rfq',
  'heatwindow': 'heatwindow-rfq',
  'kitchenhood-cleaning': 'kitchenhood-cleaning-rfq',
  'demolition': 'demolition-rfq',
  'soundprooffloor': 'soundprooffloor-rfq',
  'cctv': 'cctv-rfq',
  'mildewcleaning': 'mildewcleaning-rfq',
  'refrigeratorcleaning': 'refrigeratorcleaning-rfq',
  'pipecleaning': 'pipecleaning-rfq',
  'carpetcleaning': 'carpetcleaning-rfq',
  'pegionremoval': 'pegionremoval-rfq',
  'boiler': 'boiler-rfq',
  'computerfix': 'computerfix-rfq',
  'lighting': 'lighting-rfq',
  'walltv': 'walltv-rfq',
  'carpet': 'carpet-rfq',
  'epoxy': 'epoxy-rfq',
  'commercialinterior': 'commercialinterior-rfq',
  'induction': 'induction-rfq',
  'waterboiler': 'waterboiler-rfq',
  'sashwindow': 'sashwindow-rfq',
  'pettraining': 'pettraining-rfq',
  'leak-detection': 'leak-detection-rfq',
  'bioceramics': 'bioceramics-rfq',
  'floor-maker': 'floor-maker-rfq',
  'veranda': 'veranda-rfq',
  'sick-house-syndrome': 'sick-house-syndrome-rfq',
  'home-styling': 'home-styling-rfq',
  'pool-maker': 'pool-maker-rfq',
  'build-house': 'build-house-rfq',
  'house-remodeling': 'house-remodeling-rfq',
  'check-house': 'check-house-rfq',
  'delivery-truck': 'delivery-truck-rfq',
  'storage': 'storage-rfq',
  'petsitting': 'petsitting-rfq',
  'building-cleaning': 'building-cleaning-rfq',
  'bulk-cleaning': 'bulk-cleaning-rfq',
  'water-control': 'water-control-rfq',
  'drain-cleaning': 'drain-cleaning-rfq',
  'flooding-restoration': 'flooding-restoration-rfq',
  'draught': 'draught-rfq',
  'insulation': 'insulation-rfq',
  'plastering': 'plastering-rfq',
  'soundproof-wall': 'soundproof-wall-rfq',
  'fire-restoration': 'fire-restoration-rfq',
  'calking': 'calking-rfq',
  'couch-cleaning': 'couch-cleaning-rfq',
  'instrumental': 'instrumental-rfq',
  'pet-haircut': 'pet-haircut-rfq',
  'pet-beauty': 'pet-beauty-rfq',
  'pet-hotel': 'pet-hotel-rfq',
  'pet-snack': 'pet-snack-rfq',
  'pet-home-cleaning': 'pet-home-cleaning-rfq',
  'electronics-repair': 'electronics-repair-rfq',
  'scooter-repair': 'scooter-repair-rfq',
  'prepaid-phone': 'prepaid-phone-rfq',
  'get-new-phone': 'get-new-phone-rfq',
  'assemble-pc': 'assemble-pc-rfq',
  'memento': 'memento-rfq',
  'led': 'led-rfq',
  'signboard': 'signboard-rfq',
  'audio-video': 'audio-video-rfq',
  'air-duct': 'air-duct-rfq',
  'air-curtain': 'air-curtain-rfq',
  'buying-kitchenware': 'buying-kitchenware-rfq',
  'selling-kitchenware': 'selling-kitchenware-rfq',
  'cloth-dryer-repair': 'cloth-dryer-repair-rfq',
  'refrigerator-repair': 'refrigerator-repair-rfq',
  'washing-machine': 'washing-machine-rfq',
  'dish-washer': 'dish-washer-rfq',
  'food-waste': 'food-waste-rfq',
  'bidet': 'bidet-rfq',
  'outdoor-fan': 'outdoor-fan-rfq',
  'fan-heater-cleaning': 'fan-heater-cleaning-rfq',
  'cleaning-furniture': 'cleaning-furniture-rfq',
  'plating': 'plating-rfq',
  'art-piece': 'art-piece-rfq',
  'frame-maker': 'frame-maker-rfq',
  'setting-furniture': 'setting-furniture-rfq',
  'furniture-moving': 'furniture-moving-rfq',
  'furniture-maker': 'furniture-maker-rfq',
  'parking-system': 'parking-system-rfq',
  'for-disabled': 'for-disabled-rfq',
  'appraisal': 'appraisal-rfq',
  'office-rent': 'office-rent-rfq',
  'buying-house': 'buying-house-rfq',
  'searching-rent': 'searching-rent-rfq',
  'searching-tenant': 'searching-tenant-rfq',
  'selling-house': 'selling-house-rfq',
  'handrail': 'handrail-rfq',
  'elevator': 'elevator-rfq',
  'retractable-gates': 'retractable-gates-rfq',
  'wall-remodeling': 'wall-remodeling-rfq',
  'rooftop': 'rooftop-rfq',
  'pet-funeral': 'pet-funeral-rfq',
  'elec-car-charger': 'elec-car-charger-rfq',
  'dust-collector': 'dust-collector-rfq',
  'water-tank': 'water-tank-rfq',
  'floor-cleaning': 'floor-cleaning-rfq',
  'weeding': 'weeding-rfq',
  'ventilation-cleaning': 'ventilation-cleaning-rfq',
  'glass-film': 'glass-film-rfq',
  'septic-tank': 'septic-tank-rfq',
  'nano-coating': 'nano-coating-rfq',
  'hammock': 'hammock-rfq',
  'instrument-maker': 'instrument-maker-rfq',
  'large-tent': 'large-tent-rfq',
  'deck': 'deck-rfq',
  'concrete': 'concrete-rfq',
  'artificial-grass': 'artificial-grass-rfq',
  'car-lane': 'car-lane-rfq',
  'greenhouse': 'greenhouse-rfq',
  'landscaping': 'landscaping-rfq',
  'atmosphere-measurement': 'atmosphere-measurement-rfq',
  'radon': 'radon-rfq',
  'ventilator-install': 'ventilator-install-rfq',
  'gas': 'gas-rfq',
  'solar-panel': 'solar-panel-rfq',
  'fish-tank': 'fish-tank-rfq',
  'fire-fighter': 'fire-fighter-rfq',
  'welding': 'welding-rfq',
  'health-club': 'health-club-rfq',
  'roof': 'roof-rfq',
  'wall-painting': 'wall-painting-rfq',
  'sculpture': 'sculpture-rfq',
  'plant': 'plant-rfq',
  'smart-device-repair': 'smart-device-repair-rfq',
  'stainless': 'stainless-rfq',
  'artwall': 'artwall-rfq',
  'mesh-net': 'mesh-net-rfq',
  'awning': 'awning-rfq',
  'excavator': 'excavator-rfq',
  'iot': 'iot-rfq',
  'pianomoving': 'pianomoving-rfq',
  'closet': 'closet-rfq',
  'shoecloset': 'shoecloset-rfq',
  'centerdoor': 'centerdoor-rfq',
  'customcloset': 'customcloset-rfq',
  'floorrepair': 'floorrepair-rfq',
  'tile': 'tile-rfq',
  'piano': 'piano-rfq',
  'windowguard': 'windowguard-rfq',
  'furnituremove': 'furnituremove-rfq',
  'school-accompany': 'school-accompany-rfq',
  'nursing': 'nursing-rfq',
  'homechef': 'homechef-rfq',
  'mosquitonet': 'mosquitonet-rfq',
  'bathroom': 'bathroom-rfq',
  'doorinstallation': 'doorinstallation-rfq',
  'wallpaper': 'wallpaper-rfq',
  'building-manager': 'building-manager-rfq',
  'bodyguard': 'bodyguard-rfq',
  'gobo-light': 'gobo-light-rfq',
  'fireplace': 'fireplace-rfq',
  'babycare': 'babycare-rfq',
  'handyman': 'handyman-rfq',
  'hand-dryer': 'hand-dryer-rfq',
  'line-arrangement': 'line-arrangement-rfq',
  'specialty-delivery': 'specialty-delivery-rfq',
  'furniturereform': 'furniturereform-rfq',
  'homeclean': 'homeclean',
  'appclean': 'appclean',
  'officeclean': 'officeclean',
  'deepclean': 'deepclean-rfq',
  'moving': 'moving-rfq',
  'internet': 'internet-rfq',
};

export const deprecatedServiceRoute = ['/internet-rfq', '/moving'];

export const mainServiceRoute = [
  '/',
  '/homeclean',
  '/appclean',
  '/officeclean',
  '/deepclean-rfq',
  '/carwash',
  '/moving-rfq',
];

export const SERVICE_CODE_TEXT_MAP = {
  'homeclean': '집청소',
  'officeclean': '사무실청소',
  'carwash': '방문 손세차',
  'appclean': '가전/침대청소',
  'officemoving-rfq': '사무실 이사',
  'moving-rfq': '이사',
  'smallmoving-rfq': '소형이사',
  'moving-concierge-rfq': '이사',
  'deepclean-rfq': '이사청소/입주청소',
} as const;

export function getRfqServiceCode(slug: string): string {
  return codes[slug] || slug;
}

export function getSlugFromServiceCode(code: string): string {
  const entry = Object.entries(codes).find((a) => a[1] === code);
  return entry?.[0] || code;
}

export function validateRfqServiceCode(slug: string): boolean {
  const _slug = slug.replace('-rfq', '');
  if (!codes.hasOwnProperty(_slug)) {
    return false;
  }
  return true;
}
